import { useAuth } from '@/hooks/useAuth';
import { useOpen } from '@/hooks/useOpen';
import { AppContent } from '@/components/layouts/AppContent';
import { AppLoader } from '@/components/shared/AppLoader';

export const App = () => {
  const isOpen = useOpen();

  useAuth();

  if (!isOpen) {
    return <AppLoader />;
  }

  return <AppContent />;
};

export default App;
